"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWebSocket = exports.jsonDeserializer = exports.SubscribeType = void 0;
const webSocket_1 = require("rxjs/webSocket");
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
var SubscribeType;
(function (SubscribeType) {
    SubscribeType["exchangeOrder"] = "pionex_order";
    SubscribeType["botOrder"] = "bu_order";
    SubscribeType["announcement"] = "web_notice";
    SubscribeType["balance"] = "balance";
})(SubscribeType = exports.SubscribeType || (exports.SubscribeType = {}));
function jsonDeserializer(e) {
    if (e.data) {
        try {
            return JSON.parse(e.data);
        }
        catch (e) {
            console.error(e);
        }
    }
    return undefined;
}
exports.jsonDeserializer = jsonDeserializer;
class BaseWebSocket {
    constructor(config) {
        this.wsUrl = "";
        this.connectionState = trade_utils_lib_1.State.UNKNOWN;
        this.dataSubject = new rxjs_1.Subject();
        this.openObserver = {
            next: event => {
                console.log(`${this.wsUrl} open success`);
                this.connectionState = trade_utils_lib_1.State.DONE;
                this.reportState();
            }
        };
        this.closeObserver = {
            next: event => {
                this.connectionState = trade_utils_lib_1.State.FAILED;
                const errorMsg = `code:${event.code}, reason:${event.reason}, message:${event.message}`;
                console.log(`${this.wsUrl} closed: ${errorMsg}`);
            }
        };
        this.webSocketConfig = config;
    }
    getWebSocketSubject(url) {
        if (url === this.wsUrl && this.webSocketSubject) {
            return this.webSocketSubject;
        }
        this.wsUrl = url;
        const wsConfig = {
            url: url,
            openObserver: this.openObserver,
            closeObserver: this.closeObserver,
            deserializer: jsonDeserializer,
        };
        this.webSocketSubject = (0, webSocket_1.webSocket)(wsConfig);
        return this.webSocketSubject;
    }
    getMulticastSubject() {
        if (!this.dataObservable) {
            this.dataObservable = this.getDataObservableImpl()
                .pipe((0, operators_1.multicast)(this.dataSubject), (0, operators_1.refCount)(), (0, operators_1.takeWhile)(data => data !== undefined));
        }
        return this.dataObservable;
    }
    closeAndClean() {
        if (this.webSocketSubject) {
            this.webSocketSubject.complete();
        }
    }
}
exports.BaseWebSocket = BaseWebSocket;
